import React, { useEffect } from "react"
import { change, Field, FormSection, reduxForm } from "redux-form"
import { FORM_NAMES } from "constants/index"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { SaveButton } from "components/Buttons"
import { FileField, TextField } from "components/RenderInput"
import validate from "./documentValidation"
import {
  addDocument,
  getDocument,
  resetDocument,
  updateDocument,
} from "store/actions"
import { connect } from "react-redux"
import { mapDocumentToApi } from "../utils"
import PropTypes from "prop-types"
import { LoadingIndicator } from "components/LoadingIndicator"

let Document = props => {
  useEffect(() => {
    if (props.feature.entity_id) {
      props.getDocument(props.feature.entity_id)
    }
    return () => {
      props.resetDocument()
    }
  }, [])

  useEffect(() => {
    if (props.document) {
      props.initializeForm({
        document: {
          dataURI: props.document.file.url,
          name: props.document.file.name,
        },
        name: props.document.name,
      })
    }
  }, [props.document])

  const handleDocumentSubmit = data => {
    if (!props.document) {
      props.addDocument(
        mapDocumentToApi({
          ...data.document_feature_form,
          status: 0,
          vendor_id: props.vendorId,
          user_id: props.userId,
          menu_item_id: props.feature.id,
          event_id: props.selectedEvent ? props.selectedEvent.id : null,
          menu_feature: 1,
          order: 0,
        })
      )
    } else {
      props.updateDocument(
        props.document.id,
        {
          menu_item_id: props.document.menu_item_id,
        },
        mapDocumentToApi({
          ...data.document_feature_form,
          status: props.document.status,
          vendor_id: props.vendorId,
          user_id: props.userId,
          menu_item_id: props.feature.id,
          event_id: props.selectedEvent ? props.selectedEvent.id : null,
          menu_feature: 1,
          order: 0,
        })
      )
    }
  }

  return (
    <FormSection name={props.form}>
      {props?.loading ? (
        <LoadingIndicator />
      ) : (
        <Card>
          <CardBody className="shadow-sm">
            <Row className="mb-3">
              <Col>
                <h3>{props.feature.label}</h3>
              </Col>
              {props.isListItem && (
                <Col xs="auto" className="mx-2">
                  <SaveButton
                    content="Cancel"
                    type="button"
                    color="light"
                    onClick={props.backButtonHandler}
                  />
                </Col>
              )}
              <Col xs="auto" className="mx-3">
                <SaveButton
                  content="Save"
                  type="button"
                  onClick={
                    props.isListItem
                      ? props.handleSubmit(props.handleAddListItem)
                      : props.handleSubmit(handleDocumentSubmit)
                  }
                />
              </Col>
            </Row>
            {props.isListItem && (
              <Card>
                <CardHeader>
                  <h4>CREATE A NAME FOR YOUR DOCUMENT</h4>
                </CardHeader>
                <CardBody>
                  <Row className="mb-2">
                    <Col>
                      <Field name="name" component={TextField} label="Name" />
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            )}
            <Card>
              <CardHeader>
                <h4>ADD DOCUMENT</h4>
              </CardHeader>
              <CardBody>
                <Row>
                  <p>
                    Upload a file in the accepted formats:
                    .xlsx,.xls,.png,.jpeg,.doc,.docx,.ppt,.pptx,.pdf
                  </p>
                  <p>
                    (<b>NOTE</b>: pdf files appear the best in the app)
                  </p>
                  <p className="mt-2">Recommend files: PNG, PDF.</p>
                  <p>
                    For Android, PPT, DOC and XSL requires Office app installed.
                  </p>
                </Row>
                <Row>
                  <Field
                    name="document"
                    component={FileField}
                    accept=".xlsx,.xls,image/png,image/jpeg,.doc,.docx,.ppt,.pptx,application/pdf,
application/vnd.openxmlformats-officedocument.spreadsheetml.sheet application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.presentationml.presentation"
                  />
                </Row>
              </CardBody>
            </Card>
            <Row className="my-2">
              <Col className="d-flex justify-content-center">
                <SaveButton
                  content="Save"
                  type="button"
                  onClick={
                    props.isListItem
                      ? props.handleSubmit(props.handleAddListItem)
                      : props.handleSubmit(handleDocumentSubmit)
                  }
                />
              </Col>
            </Row>
          </CardBody>
        </Card>
      )}
    </FormSection>
  )
}

Document = reduxForm({
  form: FORM_NAMES.DOCUMENT_FEATURE,
  validate,
})(Document)

const mapStateToProps = state => ({
  document: state.Document.document,
  loading: state.Document.loading,
  vendorId: state.Login.vendorId,
  userId: state.Login.authUser.id,
  selectedEvent: state.experiences.selectedEvent,
})

const mapDispatchToProps = dispatch => ({
  getDocument: values => dispatch(getDocument(values)),
  resetDocument: () => dispatch(resetDocument()),
  initializeForm: values =>
    dispatch(
      change(FORM_NAMES.DOCUMENT_FEATURE, "document_feature_form", values)
    ),
  addDocument: values => dispatch(addDocument(values)),
  updateDocument: (featureId, menuItemId, params) =>
    dispatch(updateDocument(featureId, menuItemId, params)),
})

Document.propTypes = {
  feature: PropTypes.object,
  handleAddListItem: PropTypes.func,
  isListItem: PropTypes.bool,
  backButtonHandler: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToProps)(Document)
